import { useSyncExternalStore } from "react";

export abstract class BaseStore {
  private listeners = new Set<() => void>();
  private version = 0;

  useSync(): void {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useSyncExternalStore(this.subscribe, this.getSnapshot);
  }

  subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  getSnapshot = (): number => this.version;

  protected emit(): void {
    this.version++;
    for (const listener of this.listeners) listener();
  }
}
